module.exports = __webpack_public_path__ + "static/media/oldresume.2f9b3f04.png";